<fgb-banner [isHomeBanner]="true" [memberName]="(member$ | async)?.FirstName ?? ''"></fgb-banner>
<div class="d-lg-none">
  <div class="bg-primary">
    <fgb-mobile-page-header [isHomePage]="true"></fgb-mobile-page-header>
  </div>

  <fgbcl-loyalty-feed-list></fgbcl-loyalty-feed-list>
</div>
<div class="bg-black">
  <fgb-membership-benefits></fgb-membership-benefits>
</div>

<div class="container">
  <div class="content-container">
    <fgb-mvp-membership-banner></fgb-mvp-membership-banner>
  </div>

  <fgbcl-announcements></fgbcl-announcements>

  <fgbcl-featured-rewards></fgbcl-featured-rewards>

  <fgbcl-scorecard-carousel [icon]="'chevron_right'" [showAllView]="true"></fgbcl-scorecard-carousel>

  <div class="content-container">
    <fgb-exclusive-offers></fgb-exclusive-offers>
  </div>
</div>
<div class="content-container">
  <fgb-testimonials-page></fgb-testimonials-page>
</div>

<div class="container">
  <div class="content-container">
    <fgb-vouchers></fgb-vouchers>
  </div>

  <div class="content-container">
    <fgb-upgrade-banner [isHomePage]="true"></fgb-upgrade-banner>
  </div>
</div>
